// src/AltArrowExpand.tsx
import { createIcon } from "@chakra-ui/icon";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var AltArrowExpand_default = createIcon({
  displayName: "ArrowExpand",
  viewBox: "0 0 24 24",
  path: /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("rect", { opacity: "0", width: "24", height: "24", fill: "white", fillOpacity: "0" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M11.6315 13.1315L7.8105 9.3105C7.3965 8.8965 6.7245 8.8965 6.3105 9.3105C5.8965 9.7245 5.8965 10.3965 6.3105 10.8105L10.9245 15.4245C11.3155 15.8155 11.9485 15.8155 12.3385 15.4245L16.9525 10.8105C17.3665 10.3965 17.3665 9.7245 16.9525 9.3105C16.5385 8.8965 15.8665 8.8965 15.4525 9.3105L11.6315 13.1315Z",
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "currentColor"
      }
    )
  ] })
});

export {
  AltArrowExpand_default
};
